const EnabledCheckIcon = ({ size, rounded }: { size: number; rounded: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size + 2}
      height={size + 2}
      viewBox="0 0 25 25"
      fill="none"
      style={{ marginLeft: '-1px', marginTop: '-1px' }}
    >
      <rect
        x="0.5"
        y="0.5"
        width="24"
        height="24"
        rx={Math.max(parseFloat(rounded) - 3, 0)}
        fill="url(#paint0_linear_1289_699)"
      />
      <path
        d="M16.5 8.5L11.5 15L9.5 13"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1289_699"
          x1="22"
          x2="8"
          y1="19"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#50CAFF" />
          <stop offset="1" stopColor="#0478FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default EnabledCheckIcon;
